module.exports = __webpack_public_path__ + "img/digitalis_farm_adatbazis.2d8ac393.png";